module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Conquete.9fa91f02-ps.jpg";